const List = () => import(/* webpackChunkName: "teacher-time-off" */ "./List.vue");

export default [{ path: "teacher-time-off/:id?", name: "teacher-time-off", component: List, props: true, meta: { requiresAuth: true } }];
